import * as React from 'react'
import { FC } from 'react'

import { ISalesFunnelSummaryCard } from '@user/store/salesFunnelSummary/typings'
import { ProjectedSales } from '../ProjectedSales'

import Box from '@mui/material/Box'
interface Props {
  summaryCard: ISalesFunnelSummaryCard
  handleClose: () => void
}

export const SalesFunnelSummaryProjectedSales: FC<Props> = (props) => {
  const { summaryCard, handleClose } = props

  const {
    wonOpportunitiesValue,
    expectedOpportunitiesValue,
    projectedSalesTotalValue,
    percentageWon,
  } = summaryCard

  return (
    <Box>
      <ProjectedSales
        closedWon={wonOpportunitiesValue}
        handleClose={handleClose}
        open={expectedOpportunitiesValue}
        percentageComplete={percentageWon}
        projected={projectedSalesTotalValue}
        showTooltip
        soldServicesSummary={summaryCard.soldServiceDetails}
        type="summary"
      />
    </Box>
  )
}

SalesFunnelSummaryProjectedSales.displayName =
  'SalesFunnelSummaryProjectedSales'
